import { UseMutateFunction } from '@tanstack/react-query';
import { useForm, SubmitHandler } from 'react-hook-form';
import { Button, message } from 'antd';

import { Input } from '../common/input';
import useTranslation from '../../customHooks/translate';
import { LoginFormInputs } from 'types';
import { useNavigate } from 'react-router-dom';

interface IProps {
  loginHandler: UseMutateFunction<any, unknown, any>;
  isLoading: boolean;
  loginError?: string | null;
  passwordError?: string | null;
}

const LoginForm = ({
  loginHandler,
  isLoading,
  loginError,
  passwordError,
}: IProps) => {
  const { register, handleSubmit, formState } = useForm<LoginFormInputs>();
  const { errors } = formState;
  const translation = useTranslation();
  const navigate = useNavigate();

  const onSubmit: SubmitHandler<LoginFormInputs> = (body) => {
    if (!body.login || !body.password) {
      message.error(translation.login.emptyFields);
      return;
    }
    loginHandler(body);
  };

  const handleRedirectRegister = () => {
    navigate('/register');
  };

  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col gap-[24px]"
      >
        <div className="flex flex-col gap-[8px]">
          <Input
            id="login"
            label={translation.register.Mail}
            placeholder={translation.register.Mail}
            error={errors.login}
            autoComplete="login"
            {...register('login', {
              required: translation.login.requiredField,
            })}
            style={{
              borderColor: errors.login || loginError ? 'red' : '',
            }}
          />
          {errors.login && (
            <span
              className="animate__animated animate__shakeX"
              style={{ color: 'red', fontSize: '12px' }}
            >
              {errors.login.message}
            </span>
          )}
          {loginError && (
            <span
              className="animate__animated animate__shakeX"
              style={{ color: 'red', fontSize: '12px' }}
            >
              {loginError}
            </span>
          )}
        </div>
        <div className="flex flex-col gap-[8px]">
          <Input
            id="password"
            label={translation.login.Password}
            placeholder="• • • • • • • •"
            error={errors.password}
            type="password"
            autoComplete="current-password"
            hasLinkToResetPassword
            style={{
              borderColor: errors.password || passwordError ? 'red' : '',
            }}
            {...register('password', {
              required: translation.login.requiredField,
            })}
          />
          {errors.password && (
            <span
              className="animate__animated animate__shakeX"
              style={{ color: 'red', fontSize: '12px' }}
            >
              {errors.password.message}
            </span>
          )}
          {passwordError && (
            <span
              className="animate__animated animate__shakeX"
              style={{ color: 'red', fontSize: '12px' }}
            >
              {passwordError}
            </span>
          )}
        </div>
        <Button
          htmlType="submit"
          className="h-[44px] rounded-md !border-0 !bg-[#6DCE92] font-medium !text-white shadow-none transition-colors duration-200 hover:!border-0 hover:!bg-[#5EC082] hover:!text-white focus:!border-0 focus:!bg-[#6DCE92] focus:!text-white active:!border-0 active:!bg-[#5EC082] active:!text-white"
          loading={isLoading}
        >
          {translation.login.SignInButton}
        </Button>
        <Button
          onClick={handleRedirectRegister}
          className="h-[44px] rounded-md !border !border-[#6DCE92] !bg-white font-medium !text-[#6DCE92] shadow-none transition-colors duration-200 hover:!border-[#6DCE92] hover:!bg-[#F3F4F6] hover:!text-[#6DCE92] focus:!border-[#6DCE92] focus:!bg-white focus:!text-[#6DCE92] active:!border-[#6DCE92] active:!bg-[#F3F4F6] active:!text-[#6DCE92]"
        >
          {translation.login.SwithToSignUpLink}
        </Button>
      </form>
    </>
  );
};

export default LoginForm;
